import React, { ComponentPropsWithoutRef, FC } from 'react';

import { useTheme } from '@mui/material';

import { Svg } from '~/assets/icons/styles';

const ChatBotHappyIcon: FC<ComponentPropsWithoutRef<'svg'>> = (props) => {
  const theme = useTheme();

  return (
    <Svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      svgColor={theme.palette.common.primary}
      {...props}
    >
      <path
        d="M0.0746642 24.2589C0.299342 22.1567 -0.937385 17.6436 2.29797 17.3466C1.52039 20.2069 1.86425 24.2862 2.40152 26.6913C1.10816 26.6307 0.0766198 25.564 0.0766198 24.2608L0.0746642 24.2589ZM33.4696 26.7089C33.1335 28.1722 32.5474 29.573 31.7757 30.6612H31.7737C28.1652 35.6667 21.0205 35.8601 15.1534 35.5748C9.59317 35.3248 3.82773 32.9451 2.53632 27.166C1.8701 24.5226 1.51064 20.4296 2.31948 17.3271C4.05439 10.5321 10.9647 5.91153 17.9473 6.00531C24.9279 5.91153 31.8343 10.5282 33.5731 17.3212C34.3624 20.2049 34.0146 24.2804 33.4715 26.7089H33.4696ZM35.9371 24.2589C35.9371 25.6011 34.8391 26.6952 33.491 26.6932C34.0302 24.2765 34.3761 20.2108 33.5946 17.3388C36.9608 17.5088 35.7202 22.1372 35.9371 24.2608V24.2589ZM33.5907 17.3212C29.5113 2.31278 6.37148 2.3245 2.30384 17.3291C-0.953009 17.6202 0.281745 22.1508 0.0609748 24.2589C0.0609748 25.5718 1.10231 26.6463 2.40739 26.7069C3.57962 32.8181 9.32746 35.3169 15.1574 35.5924C21.0263 35.8777 28.173 35.6842 31.7874 30.6788H31.7893C32.5669 29.5847 33.153 28.18 33.491 26.7089C34.8488 26.7128 35.9566 25.6128 35.9566 24.2589C35.7417 22.1196 36.9804 17.4912 33.5926 17.3212H33.5907Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.18533 25.2335C2.77474 18.3505 5.39081 11.7704 12.1819 8.98438C12.1839 8.98634 13.8406 10.6099 13.8426 10.6118H22.0423L23.705 8.98438C30.5019 11.7782 33.1101 18.3466 31.7015 25.2335M31.6996 25.251C31.1134 29.3519 28.2141 32.3274 24.0566 33.2163C18.0431 34.3651 8.58119 34.7051 5.25792 28.5177C4.72455 27.4959 4.39633 26.3822 4.19119 25.251M23.7069 8.9668H23.701L22.0365 10.5962H13.8504L12.1878 8.96484C5.39667 11.7079 2.73961 18.4345 4.17364 25.2452C5.3361 33.5074 14.2919 34.3534 21.1456 33.7224C24.9338 33.3551 28.7299 32.0871 30.5488 28.713C31.7035 26.5932 32.0004 24.114 32.0454 21.496C32.3541 16.0666 28.7768 10.9908 23.7089 8.96875L23.7069 8.9668Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2835 28.0178C14.7485 32.4703 21.3462 32.3843 21.7232 27.9201C21.7447 27.6739 21.5455 27.4668 21.3149 27.4688L14.682 27.5547C14.4515 27.5586 14.2581 27.7716 14.2835 28.0158V28.0178Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.4362 20.8672L25.25 23.4617C24.9609 23.8036 24.537 23.999 24.0915 23.9951C23.6441 23.9912 23.2221 23.79 22.9407 23.4422L20.78 20.7988C20.2525 20.1541 20.3442 19.2026 20.987 18.6751C21.6278 18.1457 22.5754 18.2395 23.1029 18.8842L24.1208 20.1287L25.1426 18.9154C25.6799 18.2785 26.6274 18.2004 27.2604 18.7396C27.5808 19.0112 27.7586 19.3902 27.7879 19.779C27.8172 20.16 27.702 20.5527 27.4382 20.8672H27.4362Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2175 20.8672L13.0313 23.4617C12.7421 23.8036 12.3182 23.999 11.8727 23.9951C11.4253 23.9912 11.0034 23.79 10.722 23.4422L8.56119 20.7988C8.03369 20.1541 8.12552 19.2026 8.7683 18.6751C9.40912 18.1457 10.3566 18.2395 10.8841 18.8842L11.902 20.1287L12.9239 18.9154C13.4611 18.2785 14.4087 18.2004 15.0417 18.7396C15.3621 19.0112 15.5398 19.3902 15.5692 19.779C15.5985 20.16 15.4832 20.5527 15.2195 20.8672H15.2175Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default ChatBotHappyIcon;
